import BasicInfo from "../../../components/basic-info/BasicInfo";

interface IGroupCert {
    data: ICertification
}

interface ICertification{
    name: string;
    issueDate: string;
    issuingOrganization: string;
  }

export default function GroupCert({ data: { name, issuingOrganization, issueDate } }: IGroupCert) {
    return (
        <div className="section">
            <div className="more-profile-info">
                <h4>Certification</h4>

                <BasicInfo title="Name Of Certification" data={name} />
                <BasicInfo title="Job Role" data={issuingOrganization} />
                <BasicInfo title="Issue Date" data={issueDate} />

            </div>

        </div>
    )
}